import { useState } from "react";
import "./App.css";

import LoginForm from "./components/LoginForm";
import MainForm from "./components/MainForm";

const App = () => {
  const [isLogged, setLogged] = useState(false)

  const renderContent = () => {
    if (!isLogged) {
      return <LoginForm handleLogin={handleLogin} />
    }
    return <MainForm />
  }

  const handleLogin = () => {
    setLogged(true)
  }

  return (
    <div className="app-wrap">
      {renderContent()}
    </div>
  );
}

export default App;
